/** Auto-generated by scripts/sync-build-info.mjs — do not edit by hand. */
export const BUILD_META = {
  appVersion: '1.0.0',
  buildTag: '7024407d5d0e53fca3492586b63ebcd0a7072fc1',
} as const;
